import App from './App'
//import Sidebar from './Sidebar.vue'
export default [
  {
    path: '/',
    name: 'search',
    components: {
      default: App,
    },
    template:'<App/>'
  }
]



// WEBPACK FOOTER //
// ./src/routes.js